import { tokens } from '@fluentui/react-components';

export const POLARIS_CARD_CAPTION_PADDING_Y = `calc(${tokens.spacingVerticalSNudge} + 4px)`;
